import { IPaginatedRequest } from '@cbgms/api/request'
import { ICreateExternalGMS, IExternalGMS } from '.'
import { HttpMethod } from '../../http-method'

export const listExternalGMS = (params: IPaginatedRequest) => ({
  method: HttpMethod.GET,
  url: '/modules/external-gms',
  params
})

export const getExternalGMS = (ExternalGMSUUID: string) => ({
  method: HttpMethod.GET,
  url: `/modules/external-gms/${ExternalGMSUUID}`
})

export const updateExternalGMS = (ExternalGMSUUID: string, data: Partial<IExternalGMS>) => ({
  method: HttpMethod.PUT,
  url: `/modules/external-gms/${ExternalGMSUUID}`,
  data
})

export const deleteExternalGMS = (ExternalGMSUUID: string, DryRun: boolean) => ({
  method: HttpMethod.DELETE,
  url: `/modules/external-gms/${ExternalGMSUUID}`,
  params: {
    DryRun
  }
})

export const createExternalGMS = (data: ICreateExternalGMS) => ({
  method: HttpMethod.POST,
  url: '/modules/external-gms',
  data
})
